import axiosInstance from '../../helpers/axiosInstance'

export default function comprarMaterialesMagento (materiales) {
    return axiosInstance.post('carritoecommerce', materiales)
        .then(response => response.data)
        .catch(error => {
          throw error;
        });
}
